<template>
  <div id="conversationcontactlist">
    
    <b-tabs content-class="mt-3">
      <b-tab title="Bot" @click="fetch('bot')" v-bind:active="this.currentType=='bot'"></b-tab>
      <b-tab title="Tutti" @click="fetch('all')" v-bind:active="this.currentType=='all'"></b-tab>
      <b-tab title="Tue" @click="fetch('mine')" v-bind:active="this.currentType=='mine'"></b-tab>
    </b-tabs> 

    <div>
      <div id="cercabox">
        <input v-model="searchstring" @keyup="searchConversation" placeholder='Cerca nelle conversazioni'>      
        <font-awesome-icon @click="resetSearch" icon="times" class="cicon" title="Notifiche non abilitate"/>      
      </div>  
      
      <spinner v-if="isLoading"></spinner>   
      <div class="messagescontainer" v-else-if="!isLoading">    
          <div role="listitem" class="list-item" :class="{selected: (conversationSelected == conversation.id)}"  v-for="conversation in conversations" :attr-manual="conversation.manual" :id="`cid_`+conversation.id" :key="conversation.id" @click="changeMsg(conversation)">
            <a class="v-list__tile v-list__tile--link v-list__tile--avatar theme--light">
              <div class="v-list__tile__avatar">
                <div class="v-avatar" style="height: 40px width: 40px">
                  <vue-letter-avatar v-if="conversation.contact.avatar==null && conversation.contact.first_name!=null" :name="conversation.contact.first_name" size='40' :rounded=true />
                  <vue-letter-avatar v-else-if="conversation.contact.avatar==null && conversation.contact.first_name==null" :name="conversation.contact.platform" size='40' :rounded=true />
                  <!-- <avatar fullname="Foo Bar" :size="60"></avatar> -->                
                  <img v-else-if="conversation.contact.avatar!=null" :src="conversation.contact.avatar" class="rb__avatar-channel-icon" :title="`${conversation.contact.first_name + ` ` + conversation.contact.last_name}`">      
                  <div class="platform" :class="`${conversation.contact.platform}`">
                    <font-awesome-icon v-if="conversation.contact.platform== 'webchat'" :icon="['fab', 'rocketchat']" />
                    <font-awesome-icon v-else-if="conversation.contact.platform== 'telegram'" :icon="['fab', 'telegram-plane']" />
                    <font-awesome-icon v-else-if="conversation.contact.platform== 'facebook'" :icon="['fab', 'facebook-f']" />                                    
                  </div>                  
              </div>
              
            </div>             
            <div class="v-list__tile__content">
              <div class="v-list__tile__title">
                <span v-if="conversation.contact.first_name!=null" class="conversationUserName">
                  <span v-if="conversation.contact.first_name!=null">{{conversation.contact.first_name}} </span>
                  <span v-if="conversation.contact.last_name!=null">{{conversation.contact.last_name}}</span>                  
                </span>
                <span v-else-if="conversation.contact.first_name==null && conversation.contact.last_name==null" class="conversationUserName">Utente Anonimo</span>
                <span class="lastMessageTime">{{dateToFromNowDaily(conversation.updated_at)}}</span>
              </div> 
              <div v-if="conversation.latest_message!=null" class="v-list__tile__sub-title">
                <span class="lastMessageText">{{conversation.latest_message.text}}</span>
              </div>
            </div>
          </a>
          <div class="notifypresent" v-if="conversation['has_been_updated']">            
            <!--<font-awesome-icon :icon="['fas', 'exclamation-circle']" />-->
            <div class="notifycounter">{{conversation['updated_count']}}</div>
          </div>
        </div>
      </div>
    </div>        
  </div>      
</template>
<script>
import vSelect  from 'vue-select'
import ConversationContactListRepository from './../../repositories/ConversationContactListRepository'
import spinner from './../../components/CustomLoader'

export default { 
  mixins: [ConversationContactListRepository], 
  components: {
    vSelect,    
    spinner
  },
  data() {
    return {
      isLoading: false,
      conversations: [],        
      conversationSelected:0,      
      previousConversationSelected:0,    
      options: [],      
      selected: {'label': '', 'code': 0},
      searchstring:'',
      currentType:'bot',  
      currentProjectID: 0
    }      
  }  
}
</script>
<style> 

.notifycounter{
    background-color: #09d261;
    padding: 3px 5px 0;
    text-align: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    color: #fff;
    margin-top: -2px;    
    display: block;
    font-size: 90%;
}

#conversationcontactlist .v-list__tile__sub-title span.lastMessageText {
    display: block;    
    max-width: 160px;
    padding: 0 10px 0 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: #9e9e9e;        
}

.notifypresent{
    color: red;
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    right: 20px;
    top: 30px;
    background-color: #fff;
}

.notifypresent .svg-inline--fa{
    background: #fff;
    border-radius: 50%;
}    

.nav-tabs{
  margin-top: 20px;
}
.nav-tabs .nav-item{
  width: 33.3%;
  padding: 0;
  text-align: center;
  font-size: 13px;
}

.nav-tabs .nav-item:last-child a{
  margin-right: -1px;
}  

.nav-tabs .nav-link{
  background: #ececec;
  border: 1px solid #ececec;
  padding: 5px 0;
}
.v-select input[type=search], .v-select input[type=search]:focus {
  z-index: 9;
}

.v-select .selected-tag{
  position:absolute;
}

.v-select .dropdown-toggle,.tab-content{
  border: none;
}

.tab-content .tab-pane{
  display:none;
}

.v-select .dropdown-toggle .clear{
  bottom:6px!important;
}

#conversationcontactlist{    
    height: 100%;
}    
#conversationcontactlist .list-item {
    background: #fff;    
    width: calc(100% - 2px);
    padding: 8px;
    cursor: pointer;
    clear: left;
    float: left; 
    position: relative;
}

#conversationcontactlist .selected.list-item {
  background: #eee;
  outline: 1px solid #fff;
}

#conversationcontactlist .v-list__tile__avatar {
    min-width: 50px;
    min-height: 100%;
    align-items: center;
    float:left;
}

#conversationcontactlist .v-list__tile__content {
    text-align: left;
    flex: 0 0 calc(100% - 50px);
    overflow: hidden;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
}

#conversationcontactlist .v-list__tile__title {
    font-size: 13px;
    height: auto;
    line-height: 20px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 0 50px 1px 0;
    overflow: visible;
    width: 100%;
    position: relative;
}

#conversationcontactlist span.conversationUserName {
    display: block;
    float: left;
    width: auto;    
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

#conversationcontactlist span.lastMessageTime {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 12px;
    letter-spacing: 0px;
    color: #9e9e9e;
}

#conversationcontactlist .v-list__tile__sub-title span.lastMessageText {
    display: block;
    float: left;
    width: 100%;
    padding: 0 30px 0 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: #9e9e9e;
}

#conversationcontactlist .platform{
    position: absolute;    
    height: 24px;
    width: 24px;
    border-radius: 50%;
    text-align: center;
    padding: 2px 5px 5px;
    bottom: -5px;
    right: -5px;    
}    

#conversationcontactlist .platform .svg-inline--fa{
    font-size: 14px;
}

#conversationcontactlist .platform.webchat{
  background-color: #DB2323;
  color:#fff;
}

#conversationcontactlist .platform.facebook{
  background-color: #3578E5;
  color:#fff;
}

#conversationcontactlist .platform.telegram{
  background-color: #08c;
  color:#fff;
}


#messagescontainer{
  overflow-y: auto;
  overflow-x: hidden;
}

.nav-tabs .nav-item a:hover{
  border-color:#fff;
}

#cercabox{
  position: relative;
}

#cercabox input {
  width: calc(100% - 10px);
  padding: 5px;
  background-color: #ececec;
  border: none;
  margin: 0 5px 10px 5px;
  border-radius: 5px;
}    

#cercabox .cicon{
    position: absolute;
    right: 11px;
    top: 6px;
    z-index: 99;
}

@media all and  (max-width: 768px){
  .nav-tabs .nav-item {
      width: 100%;      
  }

  .nav-tabs .nav-link{
    padding: 15px 0;
    border: none;
  }  

  .nav-tabs {
    margin-top: 0;
  }

  #cercabox{
    display:none
  }
}    
</style>